import React from 'react';

import classNames from 'classnames';

import PureInput from '../PureInput/';

class Input extends React.Component {
    static defaultProps = {
        addon: false,
        addonContent: '',
        addonPosition: 'left',
        addonClassName: ''
    };

    /**
     * Renders the input field with/out the addon
     */
    render() {
        const {
            addon,
            addonContent,
            field,
            addonPosition,
            addonClassName,
            ...restProps
        } = this.props;
        return addon ? (
            <div
                className={classNames(
                    'addon-wrapper',
                    addonPosition,
                    addonClassName
                )}>
                <span>{addonContent}</span>
                <PureInput {...restProps} {...field} />
            </div>
        ) : (
            <PureInput {...restProps} {...field} />
        );
    }
}

export default Input;
